import { useCallback, useState } from "react";
import { useEditCurrentMerchantInstitution } from "../../../../hooks/queries/useMerchantQueries";
import useMerchantInstitutionForm from "../../../ManageMerchant/hooks/useMerchantForm";
import { toastService } from "../../../../providers";

const allowedEditFields = new Set([
  "merchantName",
  "nationality",
  "address",
  "country",
  "city",
  "county",
]);


const useMerchantEditHandler = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("edit");

  const {
    mutate: merchantInstitutionEdit,
    isPending: merchantInstitutionEditing,
  } = useEditCurrentMerchantInstitution();

  const merchantForm = useMerchantInstitutionForm("edit");

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
    merchantForm.resetToDefaults();
  }, [merchantForm]);

  const handleEditMerchant = useCallback(
    (merchant) => {
      if (!merchant) {
        toastService.error(
          "Merchant data is unavailable. Cannot edit. Please try again.",
        );
        return;
      }
      setModalMode("edit");
      merchantForm.setMode("edit");
      setModalOpen(true);
      merchantForm.reset(
        {
          merchantName: merchant.merchantName || "",
          nationality: merchant.nationality || "",
          address: merchant.address || "",
          country: merchant.country || null,
          city: merchant.city || "",
          county: merchant.county || "",
        },
        { keepDefaultValues: true },
      );
    },
    [merchantForm],
  );

  const onSubmit = useCallback(
    (values) => {
      const payload = Object.fromEntries(
        Object.entries(values).filter(([key]) => allowedEditFields.has(key)),
      );

      merchantInstitutionEdit(payload, {
        onSuccess: () => {
          toastService.success("Merchant institution edited successfully!");
          setModalOpen(false);
          merchantForm.resetToDefaults();
        },
        onError: () => {
          toastService.error("Failed to edit merchant institution");
        },
      });
    },
    [merchantInstitutionEdit, merchantForm],
  );

  return {
    modalOpen,
    modalMode,
    handleCloseModal,
    handleEditMerchant,
    handleSubmit: merchantForm.handleSubmit(onSubmit),
    merchantForm,
    isSubmitting: merchantInstitutionEditing,
    disableSubmit: merchantInstitutionEditing,
  };
};

export default useMerchantEditHandler;
